import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = [
        "eventCodeHidden", "eventCode", "eventCodeArrow", "eventCodeDropdown",
        "startDate","startTime"
    ]

    EVENT_CODES = [];
    


    connect()
    {
        let now = Date.now();
        setTimeout(() =>
        {
            this.startDateTarget._flatpickr.setDate(now);
            this.startTimeTarget._flatpickr.setDate(now);
        }, 300);
        
    }

    handleResponse(event)
    {
        if (event.detail[0].success)
        {
            const editEvent = new CustomEvent("show-toast", { detail: "Manual Event successfully submitted!" });
            window.dispatchEvent(editEvent);
        }
        else
        {
            const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: " + event.detail[0].error })
            window.dispatchEvent(errorEvent);
        }
    }

}